import {
    getMeta,
    getMetaOrFail,
} from '@precon-tools-suite-by-shared/browser-utils';

export function getScopes(
    appRegistrationName: string | undefined = undefined
): string[] {
    let scope: string | undefined = undefined;
    const apiIdentifierUri = getMeta('importapi-identifier-uri');
    if (apiIdentifierUri) {
        scope = `${apiIdentifierUri}/Imports.All`;
    } else {
        const tenantId = getMetaOrFail('msal-tenant-id');
        const apiIdentifier = appRegistrationName ?? 'ImportApi';
        scope = `https://${tenantId}/${apiIdentifier}/Imports.All`;
    }

    return [scope];
}
